export default __webpack_public_path__ + "static/media/andes_a_la_costa_12.38ec52f8.JPG";